<template>
    <AuthWrapper>
        <AuthTop
            heading="Reset password"
            text="Enter a new password below that you wish to use for your account"
        />
        <AuthForm
            :form-data="{...formData, token, email}"
            button-label="Reset"
            endpoint="/api/password/reset"
            @callback="successHandler"
        >
            <FormGroup
                label="Password"
                label-for="password"
            >
                <InputField
                    v-model="formData.password"
                    :required="true"
                    name="password"
                    type="password"
                    autocomplete="new-password"
                >
                    <template v-slot:icon>
                        <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    </template>
                </InputField>
            </FormGroup>
            <FormGroup
                label="Confirm password"
                label-for="password_confirmation"
            >
                <InputField
                    v-model="formData.password_confirmation"
                    :required="true"
                    name="password_confirmation"
                    type="password"
                    autocomplete="new-password"
                >
                    <template v-slot:icon>
                        <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    </template>
                </InputField>
            </FormGroup>
        </AuthForm>
        <AuthLink
            label="Go back to the login screen"
            link="/login"
        />
    </AuthWrapper>
</template>

<script>
import AuthWrapper from '../../components/auth/AuthWrapper.vue';
import AuthForm from '../../components/auth/AuthForm.vue';
import AuthLink from '../../components/auth/AuthLink.vue';
import AuthTop from '../../components/auth/AuthTop.vue';
import FormGroup from '../../components/form/FormGroup.vue';
import InputField from '../../components/form/InputField.vue';

export default {
    metaInfo: {
        title: 'Reset password',
    },
    components: {
        AuthWrapper,
        AuthForm,
        AuthLink,
        AuthTop,
        FormGroup,
        InputField,
    },
    data: () => ({
        formData: {
            password: null,
            password_confirmation: null,
        },
    }),
    computed: {
        token() {
            return this.$route.params.token;
        },
        email() {
            return this.$route.query.email;
        },
    },
    methods: {
        successHandler(data) {
            this.$toasted.show(data.status);
            this.$router.push({ name: 'login' });
        },
    },
};
</script>
